/*!
 * v-file-input v0.1.2
 * (c) 2020 shrpne
 * Released under the MIT License.
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.VFileInput = global.VFileInput || {})));
}(this, (function (exports) { 'use strict';

(function(){
    "use strict";
    if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            value: function (callback, type, quality) {
                var canvas = this;
                setTimeout(function() {
                    var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
                        len = binStr.length,
                        arr = new Uint8Array(len);

                    for (var i = 0; i < len; i++ ) {
                      arr[i] = binStr.charCodeAt(i);
                    }

                    callback( new Blob( [arr], {type: type || 'image/png'} ) );

                });
            }
        });
    }
})();

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]';
var undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;
var nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

// emitted events
var EVENT_DRAG_START = 'on-drag-start';
var EVENT_DRAG_END = 'on-drag-end';
var EVENT_ADD = 'on-add';
var EVENT_ERROR = 'on-error';

var fileId = 0;
var isDragOver = false;
var isDragOverEmitted = false;

var FileInput = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"file-input",attrs:{"type":"file","multiple":_vm.multiple,"disabled":_vm.disabled,"accept":_vm.accept},on:{"change":_vm.onChange}})},staticRenderFns: [],
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        accept: {
            type: String,
        },
        maxWidth: {
            type: Number,
        },
        maxHeight: {
            type: Number,
        },
    },
    data: function data() {
        return {
            fileApiError: false,
        };
    },
    computed: {
        /**
         * @returns {Array<string>} - array of mime-types suitable substring check
         */
        acceptedTypes: function acceptedTypes() {
            if (typeof this.accept !== 'string') {
                return [];
            }
            var types = this.accept.split(',');
            return types
                // 'image/*' => 'image'
                .map(function (type) { return type.replace('/*', '').trim(); })
                .filter(function (type) { return !!type.length; });
        },
        emitDragState: function emitDragState() {
            var this$1 = this;

            return throttle(function () {
                if (isDragOver && !isDragOverEmitted && !this$1.disabled) {
                    this$1.$emit(EVENT_DRAG_START);
                    isDragOverEmitted = true;

                } else if (!isDragOver && isDragOverEmitted) {
                    this$1.$emit(EVENT_DRAG_END);
                    isDragOverEmitted = false;
                }
            }, 50);
        },
    },
    beforeMount: function beforeMount() {
        if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
            this.$emit(EVENT_ERROR);
            this.fileApiError = true;
        }
    },
    mounted: function mounted() {
        if (this.fileApiError) {
            return;
        }

        // предотвращение замены страницы картинкой
        addEvents(['dragover', 'drop'], this.preventPageReload);

        // drop на все окно
        window.addEventListener('drop', this.onDrop);
        // paste на окно
        window.addEventListener('paste', this.onPaste);

        // уведомление о drag на все окно
        addEvents(['dragenter', 'dragover'], this.onDragEnter);
        addEvents(['dragleave', 'dragend', 'drop'], this.onDragLeave);

        /**
         * Add event listeners to array of events
         * @param {Array<string>} events
         * @param {Function} callback
         */
        function addEvents(events, callback) {
            events.forEach(function (eventName) {
                window.addEventListener(eventName, callback);
            });
        }
    },
    destroyed: function destroyed() {
        if (this.fileApiError) {
            return;
        }

        removeEvents(['dragover', 'drop'], this.preventPageReload);
        window.removeEventListener('drop', this.onDrop);
        window.removeEventListener('paste', this.onPaste);
        removeEvents(['dragenter', 'dragover'], this.onDragEnter);
        removeEvents(['dragleave', 'dragend', 'drop'], this.onDragLeave);

        /**
         * Remove event listeners from array of events
         * @param {Array<string>} events
         * @param {Function} callback
         */
        function removeEvents(events, callback) {
            events.forEach(function (eventName) {
                window.removeEventListener(eventName, callback);
            });
        }
    },

    methods: {
        onChange: function onChange(e) {
            if (this.fileApiError || this.disabled) {
                return;
            }
            e.preventDefault();
            this.processFiles(e.target.files);
        },
        onDrop: function onDrop(e) {
            //@TODO drop folder @see https://github.com/lian-yue/vue-upload-component/blob/master/src/FileUpload.vue
            if (this.disabled) {
                return;
            }
            if (e.dataTransfer.files.length) {
                this.processFiles(e.dataTransfer.files);
            }
        },
        onPaste: function onPaste(e) {
            if (this.disabled) {
                return;
            }
            var files = [];
            for (var index in e.clipboardData.items) {
                var item = e.clipboardData.items[index];
                if (item.kind === 'file') {
                    files.push(item.getAsFile());
                }
            }
            if (files.length) {
                this.processFiles(files);
            }
        },
        onDragEnter: function onDragEnter() {
            isDragOver = true;
            this.emitDragState();
        },
        onDragLeave: function onDragLeave() {
            isDragOver = false;
            this.emitDragState();
        },
        preventPageReload: function preventPageReload(e) {
            e.preventDefault();
        },
        /**
         * @param {FileList} fileList
         */
        processFiles: function processFiles(fileList) {
            var this$1 = this;

            var count = this.multiple ? fileList.length : 1;
            var filePromiseList = [];
            var result = [];
            // чтение каждого файла
            var loop = function ( i ) {
                var file = fileList[i];
                if (!this$1.isAcceptedFile(file)) {
                    return;
                }
                var filePromise = new Promise(function (resolve) {
                    // resize file if needed
                    var dimensionPromise = new Promise(function (resolveDimension) {
                        if (file.type.match('image.*') && (this$1.maxWidth || this$1.maxHeight)) {
                            resizeImage(file, this$1.maxWidth, this$1.maxHeight)
                                .then(resolveDimension);
                        } else {
                            resolveDimension(file);
                        }
                    });

                    // file have acceptable dimensions
                    dimensionPromise.then(function (file) {
                        this$1.getDataUrlFromBlob(file).then(function (dataUrl) {
                            result[i] = {
                                id: fileId,
                                dataUrl: dataUrl,
                                name: file.name,
                                size: file.size,
                                type: file.type,
                                blob: file,
                            };
                            fileId++;
                            resolve();
                        });
                    });
                });

                filePromiseList.push(filePromise);
            };

            for(var i = 0; i < count; i++) loop( i );
            if (!filePromiseList.length) {
                return;
            }
            Promise.all(filePromiseList).then(function () {
                // передача файлов наверх
                this$1.$emit(EVENT_ADD, result);
            });
        },
        /**
         * @TODO consider not exposing data url for performance purpose. Users will have to use FileReader or URL.createObjectURL() (https://twitter.com/andrey_sitnik/status/1060157747189170176)
         * @param {File|Blob} file
         * @return {Promise<string>} - promise resolves with dataURL
         */
        getDataUrlFromBlob: function getDataUrlFromBlob(file) {
            return new Promise(function (resolve) {
                var reader = new FileReader();
                reader.onload = function (event) {
                    resolve(event.target.result);
                };
                reader.readAsDataURL(file);
            });
        },
        /**
         * Проверяет, что файл соответствует принимаемым mime-type'ам
         * @TODO нет проверки на расширение файла
         * @param {File} file
         * @return {boolean}
         */
        isAcceptedFile: function isAcceptedFile(file) {
            if (!this.acceptedTypes.length) {
                // нет ограничений на типы
                return true;
            }
            return this.acceptedTypes.some(function (type) { return file.type.indexOf(type) === 0; });
        },
    }
};

/**
 * Resize File to given dimensions
 * @TODO consider using better resizing algorithm https://stackoverflow.com/a/24775332/4936667 or https://github.com/nodeca/pica
 * @param {File|Blob} file
 * @param {number} maxWidth
 * @param {number} maxHeight
 * @return {Promise<Blob>}
 */
function resizeImage(file, maxWidth, maxHeight) {
    return new Promise(function (resolve) {
        var img = new Image;
        var url = URL.createObjectURL(file);
        img.onload = function () {
            URL.revokeObjectURL(url);
            var width = img.width;
            var height = img.height;

            var scale = 1;
            if (width > height) {
                if (width > maxWidth) {
                    scale = maxWidth / width;
                }
            } else {
                if (height > maxHeight) {
                    scale = maxHeight / height;
                }
            }
            if (scale === 1) {
                resolve(file);
                return;
            }

            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");

            getOrientation(file, function (orientation) {
                drawImage(canvas, ctx, img, width, height, orientation, scale);
                canvas.toBlob(resolve, file.type);
            });

        };
        img.src = url;
    });
}

/**
 * Draw image on canvas according to EXIF orientation data
 * https://stackoverflow.com/a/40867559/4936667
 */
function drawImage(canvas, ctx, img, width, height, orientation, scale) {
    // set proper canvas dimensions before transform & export
    if (4 < orientation && orientation < 9) {
        // 5-8
        canvas.width = height * scale;
        canvas.height = width * scale;
    } else {
        // 1-4
        canvas.width = width * scale;
        canvas.height = height * scale;
    }

    // transform context before drawing image
    ctx.scale(scale, scale);
    switch (orientation) {
        case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
        case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
        case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
        case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
        case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
        case 7: ctx.transform(0, -1, -1, 0, height, width); break;
        case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
    }

    // draw image
    ctx.drawImage(img, 0, 0);
}


/**
 * https://stackoverflow.com/a/32490603/4936667
 * @param {File|Blob} file
 * @param {Function<number>} callback
 */
function getOrientation(file, callback) {
    var reader = new FileReader();
    reader.onload = function (e) {

        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
            return callback(-2);
        }
        var length = view.byteLength, offset = 2;
        while (offset < length) {
            if (view.getUint16(offset + 2, false) <= 8) { return callback(-1); }
            var marker = view.getUint16(offset, false);
            offset += 2;
            if (marker === 0xFFE1) {
                if (view.getUint32(offset += 2, false) !== 0x45786966) {
                    return callback(-1);
                }

                var little = view.getUint16(offset += 6, false) === 0x4949;
                offset += view.getUint32(offset + 4, little);
                var tags = view.getUint16(offset, little);
                offset += 2;
                for (var i = 0; i < tags; i++) {
                    if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                        return callback(view.getUint16(offset + (i * 12) + 8, little));
                    }
                }
            } else if ((marker & 0xFF00) !== 0xFF00) {
                break;
            } else {
                offset += view.getUint16(offset, false);
            }
        }
        return callback(-1);
    };
    reader.readAsArrayBuffer(file);
}

function plugin (Vue) {
    Vue.component('file-input', FileInput);
}

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

var version = '0.1.2';

exports['default'] = plugin;
exports.FileInput = FileInput;
exports.version = version;

Object.defineProperty(exports, '__esModule', { value: true });

})));
